import FpDashboard from 'forepaas/dashboarding/templates/default.jsx'

class MyDashboard extends FpDashboard {
}

export default MyDashboard
